import { render, staticRenderFns } from "./addNewBrand.vue?vue&type=template&id=69a058a8&"
import script from "./addNewBrand.vue?vue&type=script&lang=js&"
export * from "./addNewBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports